import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "@Services/axiosWrapper";
import { deleteIssuesData } from "./issues";
import { showToastNotification } from "@Reducers/toastSlice";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { t, untranslated } from "@i18n";
import type { DeleteIssuesDataRequest, DeleteIssuesDataResponse } from "@ServerTypes/issues/issues.schema.js";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

export function deleteIssueData(id: ObjectIdString[]) {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    const data: DeleteIssuesDataRequest = { id };
    const response = await axiosWrapper.post<DeleteIssuesDataResponse>(
      `${getBackendUrl()}/issues/deleteIssuesData`,
      data,
    );
    if (response.data.status) {
      dispatch(deleteIssuesData(id));
      dispatch(
        showToastNotification({
          content: t("Issue(s) has been successfully deleted."),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      return true;
    }
    dispatch(
      showToastNotification({
        content: response.data?.errorMessage ? untranslated(response.data.errorMessage) : SOMETHING_WENT_WRONG,
        type: TOAST_TYPE_ERROR,
      }),
    );
    return false;
  };
}
